module.exports = __webpack_public_path__ + "img/98.acdae45b.jpg";